import React from 'react';
import { useTranslation } from 'react-i18next';

import {openGameModal} from '../../modal/modal_game';

const SearchResult = React.memo(({ searchResults, loading, game_count, getProviderIcon }) => {
  const { t } = useTranslation();
  return (
    <div className="body main-layout-item ColumnSection_list">
      <div className="Home_root">
        <div className="Home_games">
          <div className="Home_header">
            <div className="HomeSection_header">
              <div className="HomeSection_label">{t('Results')}:</div>
              <div className="HomeSection_right">
                <div className="HomeSection_caption">{t('Find')}</div>
                <div className="HomeSection_caption">
                  <strong>{game_count} {t('Games')}</strong>
                </div>
              </div>
            </div>
          </div>
          <div className="HomeSectionCasinoGames_list">
            {searchResults.map((game, index) => (
              <div
                className="HomeSectionCasinoGames_game"
                key={game.id || index} // Уникнення конфліктів із ключами
              
               
                onClick={() => openGameModal(game.id)}
              >
                <div className="CasinoGameCard_root">
                  <div className="CasinoGamePreview_root">
                    <img
                      className="ResponsivePicture_img CasinoGamePreview_image"
                      src={game.thumbnail}
                      alt={game.name}
                      loading="lazy"
                    />
                  </div>
                  <div className="CasinoGameCard_info CasinoGameCard_withProvider">
                    <div className="CasinoGameCard_provider">
                      <img
                        alt={game.provider}
                        src={getProviderIcon(game.provider_slug)}
                        className="CasinoGameCard_icon"
                      />
                      <p className="CasinoGameCard_name">{game.provider}</p>
                    </div>
                    <p className="CasinoGameCard_gameName">{game.name}</p>
                  </div>
                </div>
              </div>
            ))}
            {loading && (
              <div className="content-loader-games">
                {t('loading')}...
                <div className="loader-games"></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default SearchResult;
